export interface IErrorReporter {
  capture(error: unknown | Error | string, context?: Record<string, unknown>): void
}

export const IErrorReporterSymbol = Symbol.for('IErrorReporter')
